(function () {
  'use strict';

  const debug = false;

  const blockedCookieNames = [
    '_fbp',
    '_ga',
    '_ga_ZH9RKL1RW2',
    'rdt_uuid',
    '_ttp',
    'ph_everydaehealth.com_posthog'
  ];

  const blockedStorageKeyNames = [
    'ph_everydaehealth.com_posthog'
  ];

  let marketingAllowed = false;

  function normalizeName(value) {
    return String(value || '').trim().toLowerCase();
  }

  const blockedCookies = new Set(
    blockedCookieNames.map(normalizeName)
  );

  const blockedStorageKeys = new Set(
    blockedStorageKeyNames.map(normalizeName)
  );

  function logBlockedCookie(cookieName, cookieString) {
    if (!debug) return;

    console.warn(
      '[Consent blocker] BLOCKED cookie write',
      {
        name: cookieName,
        attemptedValue: cookieString,
        time: new Date().toISOString(),
        stack: new Error().stack
      }
    );
  }

  function logBlockedStorage(storageName, key, value) {
    if (!debug) return;

    console.warn(
      '[Consent blocker] BLOCKED storage write',
      {
        storage: storageName,
        key: key,
        attemptedValue: value,
        time: new Date().toISOString(),
        stack: new Error().stack
      }
    );
  }

  function logRemovedCookie(cookieName) {
    if (!debug) return;

    console.error(
      '[Consent blocker] REMOVED existing cookie',
      {
        name: cookieName,
        time: new Date().toISOString()
      }
    );
  }

  function logRemovedStorage(storageName, key, value) {
    if (!debug) return;

    console.error(
      '[Consent blocker] REMOVED existing storage value',
      {
        storage: storageName,
        key: key,
        previousValue: value,
        time: new Date().toISOString()
      }
    );
  }

  const cookieOwner =
    Object.getOwnPropertyDescriptor(
      Document.prototype,
      'cookie'
    )
      ? Document.prototype
      : HTMLDocument.prototype;

  const nativeCookie =
    Object.getOwnPropertyDescriptor(
      cookieOwner,
      'cookie'
    );

  const nativeStorageSetItem =
    Storage.prototype.setItem;

  const nativeStorageRemoveItem =
    Storage.prototype.removeItem;

  const nativeStorageGetItem =
    Storage.prototype.getItem;

  function getStorageName(storageObject) {
    try {
      if (storageObject === window.localStorage) {
        return 'localStorage';
      }

      if (storageObject === window.sessionStorage) {
        return 'sessionStorage';
      }
    } catch (error) {
      // Storage may be unavailable in restricted browser contexts.
    }

    return 'unknown storage';
  }

  function removeBlockedValues() {
    if (
      nativeCookie &&
      typeof nativeCookie.get === 'function' &&
      typeof nativeCookie.set === 'function'
    ) {
      const currentCookies =
        nativeCookie.get.call(document);

      const existingCookieNames = new Set(
        currentCookies
          .split(';')
          .map(function (cookie) {
            return normalizeName(
              String(cookie).split('=', 1)[0]
            );
          })
          .filter(Boolean)
      );

      const hostname =
        window.location.hostname;

      const hostnameParts =
        hostname.split('.');

      const likelyRootDomain =
        hostnameParts.length >= 2
          ? hostnameParts.slice(-2).join('.')
          : hostname;

      blockedCookieNames.forEach(
        function (cookieName) {
          const existedBeforeRemoval =
            existingCookieNames.has(
              normalizeName(cookieName)
            );

          const deletionAttempts = [
            cookieName +
              '=; Max-Age=0; Path=/',

            cookieName +
              '=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/',

            cookieName +
              '=; Max-Age=0; Path=/; Domain=' +
              hostname,

            cookieName +
              '=; Max-Age=0; Path=/; Domain=.' +
              hostname,

            cookieName +
              '=; Max-Age=0; Path=/; Domain=' +
              likelyRootDomain,

            cookieName +
              '=; Max-Age=0; Path=/; Domain=.' +
              likelyRootDomain
          ];

          deletionAttempts.forEach(
            function (cookieValue) {
              try {
                nativeCookie.set.call(
                  document,
                  cookieValue
                );
              } catch (error) {
                if (debug) {
                  console.debug(
                    '[Consent blocker] Cookie deletion attempt failed',
                    {
                      name: cookieName,
                      attemptedDeletion:
                        cookieValue,
                      error: error
                    }
                  );
                }
              }
            }
          );

          if (existedBeforeRemoval) {
            logRemovedCookie(cookieName);
          }
        }
      );
    }

    blockedStorageKeyNames.forEach(
      function (key) {
        try {
          const localValue =
            nativeStorageGetItem.call(
              window.localStorage,
              key
            );

          if (localValue !== null) {
            nativeStorageRemoveItem.call(
              window.localStorage,
              key
            );

            logRemovedStorage(
              'localStorage',
              key,
              localValue
            );
          }
        } catch (error) {
          if (debug) {
            console.debug(
              '[Consent blocker] Could not inspect localStorage',
              {
                key: key,
                error: error
              }
            );
          }
        }

        try {
          const sessionValue =
            nativeStorageGetItem.call(
              window.sessionStorage,
              key
            );

          if (sessionValue !== null) {
            nativeStorageRemoveItem.call(
              window.sessionStorage,
              key
            );

            logRemovedStorage(
              'sessionStorage',
              key,
              sessionValue
            );
          }
        } catch (error) {
          if (debug) {
            console.debug(
              '[Consent blocker] Could not inspect sessionStorage',
              {
                key: key,
                error: error
              }
            );
          }
        }
      }
    );
  }

  function refreshConsent() {
    let newMarketingAllowed = false;

    try {
      newMarketingAllowed = Boolean(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy
          .marketingAllowed === 'function' &&
        window.Shopify.customerPrivacy
          .marketingAllowed()
      );
    } catch (error) {
      newMarketingAllowed = false;
    }

    const consentChanged =
      newMarketingAllowed !== marketingAllowed;

    marketingAllowed =
      newMarketingAllowed;

    if (debug && consentChanged) {
      console.info(
        '[Consent blocker] Marketing consent changed',
        {
          marketingAllowed:
            marketingAllowed,
          time: new Date().toISOString()
        }
      );
    }

    if (!marketingAllowed) {
      removeBlockedValues();
    }
  }

  /*
   * Send Clarity's initial consent state once, based on Shopify's
   * current consent mode. A separate script can handle later updates.
   */
  function initializeClarityConsent() {
    const customerPrivacy =
      window.Shopify &&
      window.Shopify.customerPrivacy;

    if (
      !customerPrivacy ||
      typeof customerPrivacy
        .marketingAllowed !== 'function' ||
      typeof customerPrivacy
        .analyticsProcessingAllowed !== 'function'
    ) {
      return false;
    }

    let advertisingAllowed = false;
    let analyticsAllowed = false;

    try {
      advertisingAllowed = Boolean(
        customerPrivacy.marketingAllowed()
      );

      analyticsAllowed = Boolean(
        customerPrivacy
          .analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }

    window.clarity =
      window.clarity ||
      function () {
        (
          window.clarity.q =
            window.clarity.q || []
        ).push(arguments);
      };

    window.clarity(
      'consentv2',
      {
        ad_Storage:
          advertisingAllowed
            ? 'granted'
            : 'denied',

        analytics_Storage:
          analyticsAllowed
            ? 'granted'
            : 'denied'
      }
    );

    if (debug) {
      console.info(
        '[Consent blocker] Initial Clarity consent set',
        {
          ad_Storage:
            advertisingAllowed
              ? 'granted'
              : 'denied',

          analytics_Storage:
            analyticsAllowed
              ? 'granted'
              : 'denied',

          time: new Date().toISOString()
        }
      );
    }

    return true;
  }

  /*
   * Block configured cookie writes and hide those cookies from
   * document.cookie reads before marketing consent.
   */
  if (
    nativeCookie &&
    typeof nativeCookie.get === 'function' &&
    typeof nativeCookie.set === 'function'
  ) {
    Object.defineProperty(
      document,
      'cookie',
      {
        configurable: true,

        get: function () {
          const currentCookies =
            nativeCookie.get.call(document);

          if (marketingAllowed) {
            return currentCookies;
          }

          return currentCookies
            .split(';')
            .map(function (cookie) {
              return String(cookie).trim();
            })
            .filter(function (cookie) {
              if (!cookie) return false;

              const cookieName =
                normalizeName(
                  cookie.split('=', 1)[0]
                );

              return !blockedCookies.has(
                cookieName
              );
            })
            .join('; ');
        },

        set: function (cookieString) {
          const cookieName =
            normalizeName(
              String(cookieString)
                .split('=', 1)[0]
            );

          if (
            !marketingAllowed &&
            blockedCookies.has(cookieName)
          ) {
            logBlockedCookie(
              cookieName,
              String(cookieString)
            );

            return cookieString;
          }

          nativeCookie.set.call(
            document,
            cookieString
          );

          return cookieString;
        }
      }
    );
  } else if (debug) {
    console.warn(
      '[Consent blocker] document.cookie could not be monkeypatched'
    );
  }

  /*
   * Block configured localStorage and sessionStorage setItem calls
   * before marketing consent.
   */
  Storage.prototype.setItem =
    function (key, value) {
      const normalizedKey =
        normalizeName(key);

      if (
        !marketingAllowed &&
        blockedStorageKeys.has(
          normalizedKey
        )
      ) {
        logBlockedStorage(
          getStorageName(this),
          key,
          value
        );

        return;
      }

      return nativeStorageSetItem.call(
        this,
        key,
        value
      );
    };

  /*
   * Default to marketing denied until Shopify's API is available.
   */
  refreshConsent();

  /*
   * Only the storage blocker is updated when consent changes.
   * Clarity consent is intentionally not updated here.
   */
  document.addEventListener(
    'visitorConsentCollected',
    refreshConsent
  );

  let clarityConsentInitialized =
    initializeClarityConsent();

  let consentCheckAttempts = 0;
  const maximumConsentCheckAttempts = 40;

  const consentCheckTimer =
    window.setInterval(
      function () {
        consentCheckAttempts += 1;

        refreshConsent();

        if (!clarityConsentInitialized) {
          clarityConsentInitialized =
            initializeClarityConsent();
        }

        const privacyApiIsAvailable =
          Boolean(
            window.Shopify &&
            window.Shopify.customerPrivacy &&
            typeof window.Shopify
              .customerPrivacy
              .marketingAllowed ===
              'function' &&
            typeof window.Shopify
              .customerPrivacy
              .analyticsProcessingAllowed ===
              'function'
          );

        if (
          privacyApiIsAvailable ||
          consentCheckAttempts >=
            maximumConsentCheckAttempts
        ) {
          window.clearInterval(
            consentCheckTimer
          );
        }
      },
      250
    );

  window.__consentStorageBlocker = {
    get marketingAllowed() {
      return marketingAllowed;
    },

    get clarityConsentInitialized() {
      return clarityConsentInitialized;
    },

    debug: debug,

    blockedCookies:
      blockedCookieNames.slice(),

    blockedStorageKeys:
      blockedStorageKeyNames.slice(),

    refreshConsent:
      refreshConsent,

    initializeClarityConsent:
      initializeClarityConsent,

    removeBlockedValues:
      removeBlockedValues
  };

  if (debug) {
    console.info(
      '[Consent blocker] Initialized',
      {
        marketingAllowed:
          marketingAllowed,
        clarityConsentInitialized:
          clarityConsentInitialized,
        blockedCookies:
          blockedCookieNames.slice(),
        blockedStorageKeys:
          blockedStorageKeyNames.slice(),
        time: new Date().toISOString()
      }
    );
  }
})();
